import { computedFrom } from 'aurelia-framework';
import { boundMethod } from 'autobind-decorator';

class MenuContainer {
  constructor(
    eventAggregator,
    router,
    appConfiguration,
    appRouting,
    appSession,
    NAVIGATION,
  ) {
    'inject';

    this.appTitle = appConfiguration.get('appTitle');
    this.currentRoute = {};
    this.currentTopRoute = {};
    this.avatar = '';
    this.avatarText = '';
    this.authenticated = false;
    this.NAVIGATION = NAVIGATION;

    this._eventAggregator = eventAggregator;
    this._router = router;
    this._appRouting = appRouting;
    this._appSession = appSession;

    this._subscriptions = [];
  }
  attached() {
    this.currentRoute = this._router.currentInstruction.config;
    this._detectCurrentTopRoute();
    this._subscriptions = [
      this._eventAggregator.subscribe(
        'router:navigation:success',
        this._onRouteChange,
      ),
      this._appSession.onSessionCreated(this._onSessionChange),
      this._appSession.onSessionChange(this._onSessionChange),
    ];

    this._onSessionChange();
  }
  detached() {
    this._subscriptions.forEach((subscription) => subscription.dispose());
    this._subscriptions = [];
  }
  validateRoute(route) {
    let valid = true;
    if (route.settings) {
      valid = this._appRouting.validate(route.settings).allowed;
    }

    return valid;
  }
  @computedFrom('currentRoute', 'authenticated')
  get showMenu() {
    let show = this.authenticated;
    if (
      this.currentRoute &&
      this.currentRoute.settings &&
      this.currentRoute.settings.hideMenu === true
    ) {
      show = false;
    }

    return show;
  }
  @boundMethod
  _onRouteChange(event) {
    this.currentRoute = event.instruction.config;
    this._detectCurrentTopRoute();
    this._onSessionChange();
  }
  @boundMethod
  _onSessionChange() {
    this.authenticated = this._appSession.isAuthenticated();
    if (this.authenticated) {
      this.avatarText = this._appSession.getSession().user.name;
      this.avatar = this.avatarText.substr(0, 1).toUpperCase();
    }
  }
  _detectCurrentTopRoute() {
    const nameParts = this.currentRoute.name.split('/');
    let topRoute;
    if (nameParts.length === 1) {
      topRoute = this.currentRoute;
    } else {
      const [name] = nameParts;
      Object.keys(this.NAVIGATION)
      .some((navigationType) => (
        this.NAVIGATION[navigationType].some((route) => {
          const result = route.name === name;
          if (result) {
            topRoute = route;
          }
          return result;
        })
      ));
    }
    this.currentTopRoute = topRoute;
  }
}

export { MenuContainer };
